import { render, staticRenderFns } from "./deleteCouponPropertyPoolDetail.vue?vue&type=template&id=70917fcc&scoped=true"
import script from "./deleteCouponPropertyPoolDetail.vue?vue&type=script&lang=js"
export * from "./deleteCouponPropertyPoolDetail.vue?vue&type=script&lang=js"
import style0 from "./deleteCouponPropertyPoolDetail.vue?vue&type=style&index=0&id=70917fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70917fcc",
  null
  
)

export default component.exports